import axios from "axios";

const API_BASE_URL = process.env.VUE_APP_API_BASE_URL

export const network = {
  namespaced: true,
  state: {
    authToken: localStorage.getItem('authToken') || '',
  },
  mutations: {
    setAuthToken(state, key) {
      state.authToken = key
      if (key !== '')
        localStorage.setItem('authToken', key)
      else
        localStorage.removeItem('authToken')
    },
    deleteAuthToken(state) {
      state.authToken = ''
      localStorage.removeItem('authToken')
    }
  },
  actions: {
    async get(_, {url, params}) {
      try {
        return await axios.get(`${API_BASE_URL}${url}`, {
          params: params
        })
          .then(response => response.data)
      } catch (e) {
        console.log('Unable to fetch data', e.message)
        throw e
      }
    },

    async post(_, {url, data}) {
      try {
        return await axios.post(`${API_BASE_URL}${url}`, data,
          {
            headers: {'Content-Type': 'application/json'}
          })
          .then(response => response.data)
      } catch (e) {
        console.log('Unable to post data', e.message)
        throw e
      }
    },

    async put({getters}, {url, data}) {
      const response = await fetch(`${API_BASE_URL}${url}`, {
        method: 'PUT',
        headers: {
          'Content-Type': 'application/json',
          ...getters.getFetchHeaders
        },
        body: JSON.stringify(data)
      })
      if (response.ok) {
        return await response.json()
      } else {
        throw new Error('Unable to put data')
      }
    },

    async delete(_, {url}) {
      try {
        return await axios.delete(`${API_BASE_URL}${url}`)
          .then(response => response.data)

      } catch (e) {
        console.log('Unable to post data', e.message)
        throw e
      }
    },

    async patch({getters}, {url, data}) {
      const response = await fetch(`${API_BASE_URL}${url}`, {
        method: 'PATCH',
        headers: {
          'Content-Type': 'application/json',
          ...getters.getFetchHeaders
        },
        body: JSON.stringify(data)
      })
      if (response.ok) {
        return await response.json()
      } else {
        throw new Error('Unable to patch data')
      }
    }
  },
  getters: {
    getFetchHeaders(state) {
      let headers = {}
      if (state.csrfToken) {
        headers['X-CSRFToken'] = state.csrfToken
      }
      if (state.authToken) {
        headers['Authorization'] = `Token ${state.authToken}`
      }
      return headers
    }
  },
}
